import React, { FC, ReactNode } from 'react'
import styled, { css } from 'styled-components'

interface BoxProps {
  pad?: number
  children: ReactNode
}

const StyledBox = styled.div<{ $pad: number }>`
  ${({ theme, $pad }) => css`
    display: flex;
    padding: ${theme.spacing($pad)};
  `}
`
const Box: FC<BoxProps> = ({ pad = 0, children }) => {
  return <StyledBox $pad={pad}>{children}</StyledBox>
}

export default Box
